<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="appointment-calendars-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Nakonfigurované kalendáře</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
          <a [routerLink]="['add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> kalendář
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-calendar-list [query]="query"></swb-calendar-list>
      </div>
    </div>
  </div>
</div>
<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="appointments-holidays-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Dovolené</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
          <a [routerLink]="['holidays/add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> dovolenou
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-appointment-holidays-list [query]="query"></swb-appointment-holidays-list>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>